import { coordinationSteps } from './coordination.tutorial';
import { projectDetailsSteps } from './projectDetails.tutorial';
import { ACTIONS, EVENTS } from 'react-joyride';
import { CustomStep } from './Tutorial';
import { taskSteps } from './task.tutorial';

export const projectSteps = (): CustomStep[] => {
  const steps: CustomStep[] = [
    // {
    //   content: <Box sx={{ width: '100%' }}>
    //     <h1>Welcome to Centerpiece!</h1>
    //     <br></br>Let us show you around....
    //   </Box>,
    //   placement: 'center',
    //   target: 'body',
    //   disableBeacon: true,
    //   floaterProps: {
    //     styles: {
    //       floater: {
    //         width: '850px',
    //         maxWidth: '95%',
    //         marginRight: 'auto',
    //         marginLeft: 'auto',
    //       },
    //     }
    //   },
    //   styles: {
    //     tooltip: {
    //       fontSize: '2vw',
    //       lineHeight: '2.5vw',
    //       width: '100%',
    //     },
    //   },
    // },
    {
      content: 'Click here to view project details',
      target: '#header-project-menu',
      disableBeacon: true,
      placement: 'auto',
      [ACTIONS.NEXT]: {
        [EVENTS.TARGET_NOT_FOUND]: 'exampleProject',
      },
      [ACTIONS.PREV]: {
        [EVENTS.STEP_AFTER]: ['indexPage', 500],
      },
    },
    {
      content: 'Click here to add project level folders/documents.',
      target: '#folderopenicon',
      disableBeacon: true,
      placement: 'auto',
      [ACTIONS.NEXT]: {
        [EVENTS.TARGET_NOT_FOUND]: 'exampleProject',
      },
      [ACTIONS.PREV]: {
        [EVENTS.STEP_AFTER]: ['indexPage', 500],
      },
    },
    {
      content: 'Hover here to add items to your project',
      styles: {
        tooltip: {
          maxWidth: '100%',
        },
        tooltipContainer: {
          maxWidth: '100%',
        },
      },
      target: '#speeddial',
      disableBeacon: true,
      placement: 'auto',
    },
    {
      content:
        'Coordination - task that requires collaboration with an external project stakeholder (that doesn’t have a Centerpiece account)',
      target: '#coordination-speeddial',
      disableBeacon: true,
      placement: 'auto',
      [ACTIONS.NEXT]: {
        [EVENTS.STEP_BEFORE]: 'openSpeedDial',
      },
    },
    {
      content:
        'Event - refers to any project-related event (install, site visit, demo’s, etc.)',
      target: '#event-speeddial',
      disableBeacon: true,
      placement: 'auto',
    },
    {
      content:
        'Task - refers to an item you and other Centerpiece users must complete',
      target: '#task-speeddial',
      disableBeacon: true,
      placement: 'auto',
    },
    {
      content:
        'Grouping - logical collection of tasks, coordinations, and events',
      target: '#grouping-speeddial',
      disableBeacon: true,
      placement: 'auto',
      // [ACTIONS.NEXT]: {
      //   [EVENTS.STEP_AFTER]: [['closeSpeedDial', 'toggleCalendar'], 500],
      // },
      // [ACTIONS.PREV]: {
      //   [EVENTS.STEP_BEFORE]: 'openSpeedDial',
      // },
    },
    {
      content:
        'Stage - collection of items for a particular part of the project (e.g. Design Stage, Bid/Quote Stage, etc.)',
      target: '#stage-speeddial',
      disableBeacon: true,
      placement: 'auto',
      [ACTIONS.NEXT]: {
        [EVENTS.STEP_AFTER]: [['closeSpeedDial', 'toggleCalendar'], 500],
      },
      [ACTIONS.PREV]: {
        [EVENTS.STEP_BEFORE]: 'openSpeedDial',
      },
    },
    {
      content:
        'As you add start and due dates to items, your full project schedule will populate here.',
      target: '#project-calendar',
      disableBeacon: true,
      placement: 'auto',
      [ACTIONS.NEXT]: {
        [EVENTS.STEP_AFTER]: 'toggleCalendar',
      },
      [ACTIONS.PREV]: {
        [EVENTS.STEP_AFTER]: 'toggleCalendar',
      },
    },
    ...projectDetailsSteps(),
    {
      content: 'Click here to hide or view children items.',
      target: '#layers-expand',
      disableScrolling: true,
      disableScrollParentFix: true,
      disableBeacon: true,
      placement: 'auto',
    },
    ...coordinationSteps(),
    ...taskSteps(),
  ];
  return steps;
};
